import { log } from 'log';
import { usePushSubscription } from 'server';
import { useDispatch } from 'react-redux';
import { MutableRefObject, useCallback } from 'react';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { showGeofencingPopupAction } from '../actions';
import * as Types from '../types';
import * as constants from '../constants';

export const useOnACLRuleFailure = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setNextTime,
    setShowOverlay,
    useTransparentPopup,
    triggerTimestampRef
}: {
    sdk: Types.GeofencingSdkInstance | null;
    nextTime: number;
    triggerGeolocation: Types.TriggerGeolocationCallback;
    setTransactionID: (transactionID: string | null) => void;
    setNextTime: (nextTime: number) => void;
    setShowOverlay: (showOverlay: boolean) => void;
    useTransparentPopup: boolean;
    triggerTimestampRef: MutableRefObject<number | null>;
}) => {
    const dispatch = useDispatch();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const closePopups = useSmartClosePopups();

    usePushSubscription(31133, () => async (pushMessage) => {
        if (!sdk) {
            return;
        }

        const { action } = pushMessage.data;
        const actionType = Object.keys(action);

        if (actionType.includes('actionAclRulesFailedInfo')) {
            const { failedAclRuleParameters = [], userError = {} } = action.actionAclRulesFailedInfo ?? {};

            if (!failedAclRuleParameters.includes('GEOLOCATION_VALIDATED')) {
                return;
            }

            const { message } = userError;

            log('gcInfo', { event: 'actionAclRulesFailedInfo' });

            dispatch(showGeofencingPopupAction({
                title: 'playtech.mobile.system.geocomply.popups.error.title',
                content: message,
                isModal: true,
                buttons: [
                    {
                        onClick: () => closePopups(),
                        text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                        color: 'negative'
                    },
                    {
                        onClick: onRefresh,
                        text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                        color: 'info'
                    }
                ],
                useTransparentPopup
            }));

            // unset current timeout
            triggerTimestampRef.current = null;
            setTransactionID(null);
            setNextTime(0);
            setShowOverlay(false);

            await triggerGeolocation({
                reason: constants.GEOLOCATION_REASON.ACL_RULE_FAILURE_CHECK
            });
        }
    }, [
        sdk,
        nextTime,
        triggerGeolocation,
        closePopups,
        onRefresh,
        dispatch,
        setTransactionID,
        setNextTime,
        setShowOverlay,
        useTransparentPopup,
        triggerTimestampRef
    ]);
};
